import * as LabelPrimitive from '@radix-ui/react-label';
import {cva} from 'class-variance-authority';
import cn from 'classnames';
import * as React from 'react';

const labelVariants = cva('leading-none peer-disabled:cursor-not-allowed');

const Label = React.forwardRef(({className, ...props}, ref) => (
    <LabelPrimitive.Root ref={ref} className={cn(labelVariants(), className)} {...props} />
));

Label.displayName = LabelPrimitive.Root.displayName;

export {Label};
